import { render, staticRenderFns } from "./CollectFile.vue?vue&type=template&id=c82c3fec&scoped=true&"
import script from "./CollectFile.vue?vue&type=script&lang=ts&"
export * from "./CollectFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82c3fec",
  null
  
)

export default component.exports